'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fixed = exports.Container = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['height:', ';'], ['height:', ';']),
    _templateObject2 = _taggedTemplateLiteral(['z-index:', ';position:fixed;top:0;left:0;right:0;background-color:', ';height:', ';box-shadow:', ';transition:box-shadow cubic-bezier(0.47,0,0.75,0.72) 0.2s;user-select:none;'], ['z-index:', ';position:fixed;top:0;left:0;right:0;background-color:', ';height:', ';box-shadow:', ';transition:box-shadow cubic-bezier(0.47,0,0.75,0.72) 0.2s;user-select:none;']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rafThrottle = require('raf-throttle');

var _rafThrottle2 = _interopRequireDefault(_rafThrottle);

var _getScrollTop = require('../utils/getScrollTop');

var _getScrollTop2 = _interopRequireDefault(_getScrollTop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* global window */

var ZINDEX = 1;

var Container = exports.Container = _styledComponents2.default.header(_templateObject, function (props) {
  return props.theme.height.header;
});

var Fixed = exports.Fixed = _styledComponents2.default.div(_templateObject2, ZINDEX, function (props) {
  return props.theme.color.grayLight;
}, function (props) {
  return props.theme.height.header;
}, function (props) {
  return props.isTop ? 'none' : '0 1px 0 0 rgba(0, 0, 0, 0.05)';
});

var LandingHeader = function (_React$PureComponent) {
  _inherits(LandingHeader, _React$PureComponent);

  function LandingHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LandingHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LandingHeader.__proto__ || Object.getPrototypeOf(LandingHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isTop: true }, _this.componentDidMount = function () {
      window.addEventListener('scroll', _this.onScroll);
      _this.onScroll();
    }, _this.componentWillUnmount = function () {
      window.removeEventListener('scroll', _this.onScroll);
      _this.onScroll.cancel();
    }, _this.onScroll = (0, _rafThrottle2.default)(function () {
      _this.setState({ isTop: (0, _getScrollTop2.default)() < _this.props.offset });
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LandingHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['children']);

      var isTop = this.state.isTop;


      return _react2.default.createElement(
        Container,
        otherProps,
        _react2.default.createElement(
          Fixed,
          { isTop: isTop },
          children
        )
      );
    }
  }]);

  return LandingHeader;
}(_react2.default.PureComponent);

LandingHeader.propTypes = {
  children: _propTypes2.default.node.isRequired,
  offset: _propTypes2.default.number
};
LandingHeader.defaultProps = {
  offset: 40
};
exports.default = LandingHeader;


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/LandingHeader/LandingHeader.js
// module id = 510
// module chunks = 4